import * as React from 'react';


export default class StarIcon extends React.PureComponent<{}> {

    public render() {
        return (
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L16.708 8.89905L25 10.1735L19 16.3186L20.416 25L13 20.8991L5.584 25L7 16.3186L1 10.1735L9.292 8.89905L13 1Z" stroke="#F3D32A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>


        );
    }
}
